import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { lineClamp } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import { ReactComponent as SvgChevron } from '@img/icons/chevron-down.svg';
import { ReactComponent as SvgExternal } from '@img/icons/chevron-down.svg';
import { ReactComponent as SvgArrow } from '@img/icons/arrow-icon.svg';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
import { NavigationDropdownMode } from '../../Navigation.types';
import { cssVar, setCssVar } from '@helpers/cssVar';
import SiteWideStyles from '@stories/Components/Global/SiteWide/SiteWide.styles';
const Container = styled(m.div) `
  ${setCssVar('accentColor', brand.sage.sageMedium)};
  ${setCssVar('bgColor', brand.sage.sageDark)};
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('fgColorAlt', brand.white)};

  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  background: ${cssVar('bgColor')};
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  z-index: 10000;
  padding-bottom: 85px;

  ${SiteWideStyles.Container} {
    display: flex;
    flex-direction: column;
  }

  @media ${from(Device.TabletLarge)} {
    min-height: 840px;
  }

  ${({ mode }) => mode === NavigationDropdownMode.TwoLevels &&
    css `
      ${Column1} {
        grid-column: 1 / span 12;
        
      }

      @media ${from(Device.TabletLarge)} {
        ${Column1} {
          grid-column: 1 / span 3;
          border-right: 1px solid ${brand.white};
        }

        ${Column2} {
          grid-column: 4 / span 3;
          border-right: 1px solid ${brand.white};

          ${BgImageHolder},
          ${LinkDescription},
          ${Arrow} {
            display: none;
          }

          ${ContentHolder} {
            ${fonts.matter.regular}
            font-size: 22px;
            line-height: 32px;
            color: ${cssVar('fgColor')};
            padding: 10px 0;
            flex: 1 0 auto;

            ${LinkTitle} {
              ${fonts.matter.regular};
            }
          }

          ${Link} {
            padding: 0;
            &:hover,
            &:focus {
              ${LinkTitle} {
                ${fonts.matter.medium};
              }
            }
          }
        }

        ${ColumnCard} {
          grid-column: 7 / span 3;

          ${ContentHolder} {
            ${fonts.gazpacho.medium};

            ${LinkTitle} {
              ${fonts.gazpacho.medium};
              font-size: 24px;
              line-height: 34px;
            }

            ${Arrow} {
              display: block;
            }
          }
        }

      }

    `}

  ${({ mode }) => mode === NavigationDropdownMode.TwoLevelsCard &&
    css `
      ${Column1} {
        grid-column: 1 / span 3;
        border-right: 1px solid ${brand.white};

        ${Chevron} {
          display: none;
        }
      }

      ${ColumnSelected} {
        grid-column: 5 / span 7;
      }

      @media ${from(Device.Desktop)} {
        ${Column1} {
          grid-column: 1 / span 3;

          ${Link} {            
            padding: 7px 15px;
            position: relative;

            &:hover,
            &:focus {
              ${LinkTitle} {
                ${fonts.matter.medium};
                font-size: 22px;
                line-height: 32px;
              }
            }
          }   

          ${BgImageHolder} {
            display: none;
          }

          ${ContentHolder} {
            padding: 0;

            ${LinkTitle} {
              ${fonts.matter.medium};
              font-size: 22px;
              line-height: 32px;
            }

            ${LinkDescription} {
              display: none;
            }

            ${Arrow} {
              display: none;
            }            
          }
        }

        ${Column2} {
          grid-column: 4 / span 8;
        }

        ${ColumnSelected} {
          position: relative;
          grid-column: 4 / span 9;

          ${List} {
            display: flex;
            gap: 30px;
          }

          ${Item} {
            flex: 0 1 28%;
          }
        }
      }


      @media ${from(Device.DesktopLarge)} {
        ${Column1} {

          ${List} {
            display: grid;
            grid-template-columns: 1fr;
            gap: 10px;
          }

          ${Link} {            
            padding: 7px 15px;
            padding-right: 70px;
            position: relative;

            &:hover,
            &:focus {
              ${LinkTitle} {
                ${fonts.matter.medium};
                font-size: 22px;
                line-height: 32px;
              }
            }
          }          

          ${BgImageHolder} {
            display: none;
          }

          ${ContentHolder} {
            ${LinkTitle} {
              ${fonts.matter.regular};
              font-size: 22px;
              line-height: 32px;
            }

            ${Arrow} {
              display: none;
            }            
          }
        }

        ${ColumnSelected} {
          position: relative;
          grid-column: 4 / span 9;


          ${List} {
            display: flex;
            gap: 30px;
          }

          ${Item} {
            flex: 0 1 352px;
          }
        }
      }

      
    `}

  ${({ mode }) => mode === NavigationDropdownMode.FourLevels &&
    css `
      ${Column1} {
        grid-column: 1 / span 3;
      }

      ${Column2} {
        grid-column: 4 / span 3;
      }

      ${Column3},
      ${ColumnCard} {
        display: none;
      }

      @media ${from(Device.TabletLarge)} {
        ${Inner} {
          grid-template-columns: repeat(24, 1fr);
        }

        ${List} {
          display: grid;
          flex-direction: column;
        }

        ${Link} {
          padding: 8px 30px 8px 15px;
          border-radius: 0;
          font-size: 20px;
          line-height: 28px;
          background-color: transparent;
        }

        ${Column1} {
          grid-column: 1 / span 6;
        }

        ${Column2} {
          grid-column: 11 / span 14;

          ${Link} {
            ${fonts.matter.regular};
          }
        }

        ${ColumnSelected} {
          position: relative;
          grid-column: 7 / span 18;


          ${List} {
            display: flex;
            flex-direction: row;
            gap: 30px;
          }

          ${Link} {
            padding: 0;
          }

          ${Item} {
            flex: 0 1 28%;
          }
        }
      }

      @media ${from(Device.Desktop)} {
        ${Column1} {
          grid-column: 1 / span 6;
          border-right: 1px solid ${brand.white};
        }

        ${Column2} {
          grid-column: 7 / span 6;
          border-right: 1px solid ${brand.white};
        }

        ${Column3} {
          display: block;
          grid-column: 13 / span 6;
          border-right: 1px solid ${brand.white};
        }

        ${Column4} {
          display: block;
          grid-column: 19 / span 6;
          margin-left: 0;
        }
      }
    `}
`;
const DropDownTop = styled.div `
  ${fonts.matter.medium};
  font-size: 22px;
  line-height: 32px;
  padding: 18px 0 33px;
`;
const Inner = styled.div `
  position: relative;
  display: flex;
  flex-direction: row;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  width: 100%;
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(12, 1fr);

  @media ${until(Device.TabletLarge)} {
    display: flex;
    gap: 0; // resetting as only chrome supports this with flex.
    max-width: none;
    padding: 0 15px;
  }

  @media ${from(Device.Desktop)} {
    gap: 40px;
  }
`;
const Column = styled(m.div) `
  display: block;
  flex: 0 1 auto;
  grid-row: 1;
  transition: opacity 0.15s ease-out;

  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  & {
    scrollbar-width: auto;
    scrollbar-color: #669900 #e5e5e5;
  }

  /* Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: 12px;
    margin-right: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #e5e5e5;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #669900;
    border-radius: 10px;
    border: 3px solid #e5e5e5;
  }
`;
const Column1 = styled(Column) `
  @supports (display: grid) {
  }
`;
const Column2 = styled(Column) `
  display: block;

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    border-color: #ffffff;
  }
`;
const Column3 = styled(Column) `
  display: none;

  ${({ isActive }) => isActive &&
    css `
      display: block;
    `}
`;
const Column4 = styled(Column) `
  display: none;

  ${({ isActive }) => isActive &&
    css `
      display: block;
    `}
`;
const ColumnCard = styled(Column) `
  display: none;

  ${({ isActive }) => isActive &&
    css `
      display: block;
    `}
`;
const ColumnSelected = styled(Column) `
  display: none;

  ${({ isActive }) => isActive &&
    css `
      display: block;
    `}
`;
const List = styled.ul `
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
`;
const Item = styled.li `
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;
const ContentHolder = styled.div `
  position: relative;
`;
const LinkTitle = styled.span `
  padding-right: 30px;

  @media ${from(Device.DesktopLarge)} {
    padding-right: 50px;
  }
`;
const Link = styled.a `
  ${fonts.matter.regular};
  position: relative;
  display: block;
  color: ${cssVar('fgColor')};
  font-size: 22px;
  line-height: 32px;
  margin: 0;
  padding: 7px 15px;
  text-decoration: none;
  overflow: hidden;

  ${Column2} & {
    font-weight: 400;
  }

  &:focus,
  &:hover {
    text-decoration: underline;

    ${({ hasImage }) => hasImage &&
    css `
        ${ContentHolder} {
          ${LinkTitle} {
            ${fonts.gazpacho.medium}
            text-decoration: underline;
          }
        }
      `}
  }

  ${({ hasImage }) => hasImage &&
    css `
      padding: 0;
      color: ${cssVar('fgColor')};
      text-decoration: none;
      font-size: 18px;
      line-height: 26px;
      display: flex;
      flex-direction: column;

      ${ContentHolder} {
        ${fonts.gazpacho.medium}
        font-size: 20px;
        line-height: 24px;
        color: ${cssVar('fgColor')};
        padding: 10px 0;
        flex: 1 0 auto;

        @media ${from(Device.Desktop)} {
          font-size: 24px;
          line-height: 28px;
        }

        ${LinkTitle} {
          ${fonts.gazpacho.medium}
        }
      }

      ${Arrow} {
        display: block;
      }
    `}

  ${({ isActive }) => isActive &&
    css `
      text-decoration: none;

      ${LinkTitle} {
        ${fonts.matter.medium};
        text-decoration: underline;
      }
    `}

    ${({ isExternal }) => isExternal &&
    css `
      padding-right: 40px;
    `}
`;
const AreaLink = styled.a `
  ${fonts.gazpacho.medium};
  position: relative;
  display: inline-block;
  color: ${cssVar('fgColor')};
  font-size: 36px;
  line-height: 42px;
  margin: 0;
  padding: 13px 15px 12px;
  text-decoration: none;
  overflow: hidden;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

`;
const LinkDescription = styled.p `
  ${lineClamp(4, 'block')};
  ${fonts.matter.regular};
  font-size: 16px;
  line-height: 24px;
  margin-top: 20px;
  color: ${cssVar('fgColor')};

  @media ${from(Device.DesktopLarge)} {
    font-size: 18px;
    line-height: 26px;
  }
`;
const BgImageHolder = styled.div `
  height: 165px;
  flex: 0 0 235px;
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;

  @media ${from(Device.DesktopLarge)} {
    height: 235px;
    margin-bottom: 30px;
  }
`;
const PromoImageWrapper = styled.div `
  margin: 20px 0;
  height: 337px;
  width: 100%;
  max-width: 528px;
  position: relative;
  overflow: hidden;
  border-radius: 24px;
`;
const BgImage = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  transform: scale(1);
  transition: transform ease-out 1s;
  width: 100%;
  
  @media (prefers-reduced-motion: reduce)  {
    transition: none;
  }
`;
const Chevron = styled(SvgChevron) `
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%) rotate(-90deg);
  display: block;
  height: 7px;
  width: 14px;

  @media ${from(Device.TabletLarge)} {
    right: 30px;
  }

  @media ${from(Device.DesktopLarge)} {
    right: 50px;
  }
`;
const External = styled(SvgExternal) `
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  display: block;
  height: 17px;
  width: 17px;
`;
const Arrow = styled(SvgArrow) `
  position: absolute;
  top: 15px;
  right: 0;
  display: block;
  height: 15px;
  width: 18px;
  display: none;
`;
export default {
    AreaLink,
    Arrow,
    BgImage,
    BgImageHolder,
    Chevron,
    Column1,
    Column2,
    Column3,
    Column4,
    ColumnCard,
    ColumnSelected,
    Container,
    ContentHolder,
    DropDownTop,
    External,
    Inner,
    Item,
    Link,
    LinkDescription,
    LinkTitle,
    List,
    PromoImageWrapper,
};
